import { SageConnectForm } from "./sage_connect_form"

export function ConnectSageIntacctPage() {
  return <SageConnectForm redirectTo="/setup/connect" />
}

// Keep the old export for backwards compatibility
export const ConnectSagePage = ConnectSageIntacctPage
